import { Action } from '@ngrx/store';

import { Favourite } from '../../models';

export enum FavouritesActionTypes {
    LOAD = '[Favourites] Load',
    LOAD_SUCCESS = '[Favourites] Load Success',
    FAVOURITES_ACTION_FAIL = '[Favourites] Load Fail',
    UPSERT = '[Favourites] Upsert',
    DELETE = '[Favourites] Delete',
    SET_FAVOURITE = '[Favourites] SetFavourite',
    UNSET_FAVOURITE = '[Favourites] UnsetFavourite',
    CLEAR = '[Favourites] Clear'
}

export class Load implements Action {
    readonly type = FavouritesActionTypes.LOAD;

    constructor() {}
}

export class LoadSuccess implements Action {
    readonly type = FavouritesActionTypes.LOAD_SUCCESS;

    constructor(public items: Favourite[]) {}
}

// To handle when Load, Set or Unset actions fail
export class FavouritesActionFail implements Action {
    readonly type = FavouritesActionTypes.FAVOURITES_ACTION_FAIL;

    constructor(public error?: any, public catalogueItemId?: number) {}
}
export class Upsert implements Action {
    readonly type = FavouritesActionTypes.UPSERT;

    constructor(public item: Favourite) {}
}

export class Clear implements Action {
    readonly type = FavouritesActionTypes.CLEAR;

    constructor() {}
}

export class Delete implements Action {
    readonly type = FavouritesActionTypes.DELETE;

    constructor(public id: number, public catalogueItemId: number) {}
}

export class SetFavourite implements Action {
    readonly type = FavouritesActionTypes.SET_FAVOURITE;

    constructor(public catalogueItemId: number) {}
}

export class UnsetFavourite implements Action {
    readonly type = FavouritesActionTypes.UNSET_FAVOURITE;

    constructor(public item: Favourite) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type FavouritesActions =
  | Load
  | LoadSuccess
  | FavouritesActionFail
  | Upsert
  | Clear
  | Delete
  | SetFavourite
  | UnsetFavourite;
